// The `forecast-component-config` entry type can hold any data; however, these are the fields that impact derived CDF
// data (i.e. tmin, RCA, RL).  Because we are in typescript, we can define the shape of the data that we expect to be
// present, and it won't throw an error if an unexpected field exists.
//
// NOTE: height, diameter, manufactured_date, nominal_by_shell_course, shell_course_elevations, and regions (prior

import { GeckoMeasurement } from 'types/measurement/geckoMeasurement'

//       repairs) should all be pulled from the RAM now
export type ForecastComponentConfig = {
  // Component Params
  tmin_by_shell_course?: Record<number, number>
  center_plate_radius?: number
  cr_by_shell_course?: Record<number, number>
  api_code_override?: string
  // API-653 Params
  specific_gravity_profile?: SpecificGravityProfileEnum
  // API-570 Params
  pipe_outer_diameter?: number
  pipe_inner_diameter?: number
  operation_pressure?: number
  allowable_unit_stress?: number
  api_570_weld_type?: API570WeldType
  binOverrides?: {
    overrides?: ReadonlyArray<{
      xCoordinate: number
      yCoordinate: number
      nominalValue: number
    }>
    x_unit: string
    y_unit: string
  }
}

export enum SpecificGravityProfileEnum {
  Linear = 'linear',
  Flat = 'flat',
}

export type SpecificGravityProfile = {
  height: GeckoMeasurement
  gravity: number
}[]

export type ConfigRegion = OverrideRegion & {
  // the date, formatted YYYY-MM-DD
  id?: string
  manufactured_date: string
  nominal_thickness: number
}
export type OverrideRegion = {
  end_x: number
  end_y: number
  start_x: number
  start_y: number
  nominal_thickness?: number
  is_nominal_additive?: boolean
}

export type API570WeldType =
  | 'dbl-welded-full-radio'
  | 'dbl-welded-spot-radio'
  | 'dbl-welded-no-radio'
  | 'sngl-welded-full-radio'
  | 'sngl-welded-spot-radio'
  | 'sngl-welded-no-radio'
